export default __webpack_public_path__ + "static/media/2.f7044207.png";